import * as React from 'react';

interface UICoreButtonProps {
    color: 'light-grey' | 'green' | 'grey';
    align: 'right' | 'block';
    label: string;
    onClick?: () => void;
}

export const UICoreButton: React.FC<UICoreButtonProps> = (props: UICoreButtonProps) => {
    const classNames: Array<string> = ['core-button'];
    if (props.color) {
        classNames.push('core-button-' + props.color);
    }
    if (props.align) {
        classNames.push('core-button-' + props.align);
    }
    if (props.onClick != null) {
        return (
            <button tabIndex={0} className={classNames.join(' ')} onClick={props.onClick} disabled={props.onClick == null}>
                <span>{props.label}</span>
            </button>
        );
    }
    return (
        <button tabIndex={0} className={classNames.join(' ')} disabled={true}>
            <span>{props.label}</span>
        </button>
    );
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/UICoreButton.tsx